import { Utils } from "../utilities/Utils";
import { mapData } from "@/utilities/DataMapping";

export interface IDocument {
    key: string;
    filename: string;
    extension: string;
    contentType: string;
    size: number;
}

export class Document implements IDocument {

    constructor(data?: IDocument) {
        if (typeof data === "undefined" || data === null) return;
        this.update(data);
    }

    update(data: IDocument) {
        mapData(data, { root: () => this });
    }

    key: string = Utils.emptyGuidValue;
    filename: string = "";
    extension: string = "";
    contentType: string = "";
    size: number = 0;

}